import { FC } from 'react';
import { LinkDriveSetupList } from './LinkDriveSetupList/LinkDriveSetupList';

export const LinkDriveSetupListPage: FC = () => {
  return <LinkDriveSetupList />;
};
